export default "__VITE_ASSET__CPdjWr3x__"